import { useState } from 'react';

export type ProfilePhoneNumberVerificationProps = {
    handleSubmitNumber: (phone: string) => void;
    invalidNumber: boolean;
    invalidPin: boolean;
};
export const ProfilePhoneNumberVerification = ({ handleSubmitNumber, invalidPin, invalidNumber }: ProfilePhoneNumberVerificationProps) => {
    const [phoneNumber, setPhoneNumber] = useState<string>('');

    const renderInfoText = () => {
        if (invalidNumber) {
            return 'Ugyldig mobilnummer! Fyll inn ditt mobilnummer og du vil motta en PIN kode.';
        } else if (invalidPin) {
            return 'Feil PIN-kode! Fyll inn ditt mobilnummer og du vil motta en PIN-kode.';
        } else {
            return 'For sikkerhets skyld. Skriv inn mobilnummeret ditt, så sender vi deg en kode. Dette er selvfølgelig gratis.';
        }
    };

    return (
        <div data-testid="requestForm">
            <p data-testid="phoneInfoText">{renderInfoText()}</p>
            <div className="input input--text input--kill-bottom-margin mb-8">
                <label htmlFor="phoneNumberInput">Mobilnummer</label>
                <input
                    id="phoneNumberInput"
                    placeholder="Mobilnummer"
                    data-testid="phoneNumberInput"
                    onChange={(event) => setPhoneNumber(event.target.value)}
                    value={phoneNumber}
                />
            </div>
            <button
                className="button button--secondary"
                data-testid="phoneNumberSubmit"
                disabled={!phoneNumber}
                onClick={() => handleSubmitNumber(phoneNumber)}>
                Send
            </button>
            <p className="text-14 mt-4">
                <a
                    href="https://hjelpesenter.finn.no/hc/no/articles/305314-Kjenn-igjen-svindelfors%C3%B8k-p%C3%A5-SMS"
                    className="link"
                    rel="noopener noreferrer"
                    target="_blank">
                    Hvorfor ber vi deg om dette?
                </a>
            </p>
        </div>
    );
};
